import { Establishment, Feature, PlanType } from './types';
import { differenceInCalendarDays } from 'date-fns';

export const basicFeatures: Feature[] = [
  'STATISTICS_EXPLORE_RESULTS',
  'PRODUCT_PRESENTATIONS',
  'PRODUCT_OPTIONS',
  'PRODUCT_GROUPS',
  'THEME',
  'QR_CODE',
  'DIGITAL_MENU',
  'SLUG_CUSTOMIZATION',
  'CHECKOUT_CUSTOM_FIELDS',
  'WORKING_HOURS',
  'ANNOUNCEMENTS',
  'ADS',
  'SECURITY',
  'INTEGRATIONS',
  'INTEGRATIONS_PUNIYA',
  'INTEGRATIONS_RAPIBOY',
  'INTEGRATIONS_PAYMENT_COLLECTION',
  'SEO_SOCIAL_MEDIA',
];

export const intermediateFeatures: Feature[] = [
  'COUPONS',
  'ANALYTICS',
  'IMAGE_GALLERY',
  'STOCK_CONTROL',
  'INVENTORY_MANAGEMENT',
  'SKU',
  'CATEGORY_AVAILABILITY',
  'THERMAL_PRINTING',
  'PRODUCT_TAGS',
  'DYNAMIC_CATEGORIES',
  'ALT_LANGUAGE',
];

export const advancedFeatures: Feature[] = [
  'DELIVERY_ZONES',
  'PRODUCTS_EXPORT',
  'IMAGE_GALLERY_EXTENDED',
  'PRODUCT_ITEM_IMAGES',
  'BULK_EDIT',
  'INTEGRATIONS_FUDO',
  'INTEGRATIONS_THINKION',
  'INTEGRATIONS_MRC',
  'INTEGRATIONS_CUCINA',
  'INTEGRATIONS_PEDIDOS_YA_MARKETPLACE',
  'INTEGRATIONS_CORREO_ARGENTINO',
  'INTEGRATIONS_ARCA',
  'PARCEL_SHIPPING',
  'ADVANCED_STATISTICS',
  'USER_MANAGEMENT',
  'ORDER_EDITOR',
  'PROMOTIONS',
  'CASH_REGISTER',
  'SUPPLIES_STOCK',
];

export const allFeatures: Feature[] = [
  ...basicFeatures,
  ...intermediateFeatures,
  ...advancedFeatures,
];

export const PLAN_TYPES_ASCENDING: PlanType[] = [
  PlanType.BASIC,
  PlanType.INTERMEDIATE,
  PlanType.ADVANCED,
];

const FEATURES_BY_PLAN_TYPE: Record<PlanType, Feature[]> = {
  [PlanType.BASIC]: basicFeatures,
  [PlanType.INTERMEDIATE]: [...basicFeatures, ...intermediateFeatures],
  [PlanType.ADVANCED]: allFeatures,
};

export const getEstablishmentFeaturesByPlan = (
  plan: string,
  features: Establishment['features'] = [],
  featureTrials: Establishment['featureTrials'] = [],
): Feature[] => {
  const initialFeatures = [
    ...features,
    ...featureTrials
      .filter(
        trial =>
          !trial.trialEndDate || differenceInCalendarDays(trial.trialEndDate, new Date()) >= 0,
      )
      .map(trial => trial.feature),
  ];
  const planType = resolvePlanType(plan, initialFeatures);

  if (!planType) {
    return initialFeatures;
  }
  return initialFeatures.concat(FEATURES_BY_PLAN_TYPE[planType]);
};

export const resolvePlanType = (plan: string, features: Feature[] = []): PlanType | null => {
  if (plan === PlanType.BASIC || plan === PlanType.INTERMEDIATE || plan === PlanType.ADVANCED) {
    return plan;
  }
  if (!plan) {
    return getHasAdvancedFeatures(features) ? PlanType.ADVANCED : PlanType.INTERMEDIATE;
  }
  return null;
};

export const getHasAdvancedFeatures = (features: Feature[] = []) => {
  return features.includes('DELIVERY_ZONES') || features.includes('PRODUCTS_EXPORT');
};
